import { render, staticRenderFns } from "./TheNotAuthorized.vue?vue&type=template&id=5b3316af&"
import script from "./TheNotAuthorized.vue?vue&type=script&lang=js&"
export * from "./TheNotAuthorized.vue?vue&type=script&lang=js&"
import style0 from "./TheNotAuthorized.vue?vue&type=style&index=0&id=5b3316af&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports